// S :::: 비디오 이미지 불러오기 :::: S
import VideoImage01 from "../assets/images/shuffle/shuffle-video01.png";
import VideoImage02 from "../assets/images/shuffle/shuffle-video02.png";
import VideoImage03 from "../assets/images/shuffle/shuffle-video03.png";
import VideoImage04 from "../assets/images/shuffle/shuffle-video04.png";
// E :::: 비디오 이미지 불러오기 :::: E

import VLAZEImage from "../assets/images/instructors/instructors-vlaze.webp";

import EUNHYEImage from "../assets/images/instructors/instructors-eunhye.webp";
import WAANOImage from "../assets/images/instructors/instructors-wanno.webp";
import HONNEYBEEIMAGE from "../assets/images/instructors/instructors-honeybee.webp";
import KYURIIMAGE from "../assets/images/instructors/instructors-kyuri.webp";

// S ::: 셔플 수강료 리스트 ::: S
export const shufflePricingList = [
  {
    type: "단체반 수업 CLASS",
    class: [
      {
        mainTitle: "셔플",
        course: [
          {
            subTitle: "4회 수업",
            desc: "*1회 쿠폰 수업 [level 1]만 가능",
            price: "16만원",
          },
          {
            subTitle: "1회 수업",
            desc: "",
            price: "4.5만원",
          },
        ],
      },
    ],
  },
  {
    type: "개인 레슨 PRIVATE",
    class: [
      {
        mainTitle: "개인 레슨",
        course: [
          {
            subTitle: "1회 수업 (60분)",
            desc: "",
            price: "10만원",
          },
          {
            subTitle: "10회 수업 (60분씩)",
            desc: "",
            price: "95만원 (회당 5000원 할인)",
          },
          {
            subTitle: "20회 수업 (60분씩)",
            desc: "",
            price: "180만원 (회당 1만원 할인)",
          },
        ],
      },
      {
        mainTitle: "그룹 레슨",
        course: [
          {
            subTitle: "2:1 수업 (60분)",
            desc: "",
            price: "14만원",
          },
          {
            subTitle: "3:1 수업 (60분)",
            desc: "",
            price: "18만원",
          },
        ],
      },
    ],
  },
];
// E ::: 셔플 수강료 리스트 ::: E

export const shuffleVideoList = [
  {
    title: "셔플 & 풋워크 클래스",
    desc: "",
    link: "https://www.youtube.com/playlist?list=PLxY9pionI4WddozmoL_wFutSbRGeWOZq3",
    img: VideoImage01,
    category: "셔플",
  },
  {
    title: "셔플 & 풋워크",
    desc: "",
    link: "https://www.youtube.com/playlist?list=PLEcIhD74XH_m1lTuWi_7NhzqfOAe1_MQC",
    img: VideoImage02,
    category: "셔플",
  },
  {
    title: "키즈 풋워크 프로",
    desc: "",
    link: "https://www.youtube.com/playlist?list=PLxY9pionI4WeUDT9EOdO6NNQEyBvig8lO",
    img: VideoImage03,
    category: "셔플",
  },
  {
    title: "전문 지도자 과정",
    desc: "",
    link: "https://www.youtube.com/playlist?list=PLxY9pionI4WfaxijXsqQneAjzSbp_mQTU",
    img: VideoImage04,
    category: "셔플",
  },
];

// S ::: 셔플 강사진 리스트 ::: S
export const shuffleInstructorsList = [
  {
    name: "VLAZE",
    img: VLAZEImage,
  },
  {
    name: "EUN HYE",
    img: EUNHYEImage,
  },
  {
    name: "WAANO",
    img: WAANOImage,
  },
  {
    name: "HONNEYBEE",
    img: HONNEYBEEIMAGE,
  },
  {
    name: "KYURI",
    img: KYURIIMAGE,
  },
];

// E ::: 셔플 강사진 리스트 ::: E
